var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolution(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5054 8.75879V44.7758C35.5054 46.9827 33.5696 48.7697 31.1794 48.7697H5.08969C2.6995 48.7697 0.763672 46.9827 0.763672 44.7758V5.26132C0.763672 3.05441 2.6995 1.26367 5.08969 1.26367H26.3532L35.5054 8.75879Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1794 49.5333H5.08965C2.28328 49.5333 0 47.3989 0 44.7758V5.26129C0 2.63437 2.28328 0.5 5.08965 0.5H26.3532C26.5288 0.5 26.7006 0.561091 26.8381 0.671819L35.9903 8.16694C36.1659 8.31203 36.269 8.52966 36.269 8.75876V44.7758C36.269 47.3989 33.9858 49.5333 31.1794 49.5333ZM5.08965 2.02728C3.1271 2.02728 1.52728 3.47819 1.52728 5.26129V44.7758C1.52728 46.5589 3.1271 48.006 5.08965 48.006H31.1794C33.1419 48.006 34.7418 46.5589 34.7418 44.7758V9.11767L26.0821 2.02728H5.08965Z",
    fill: "#FF8C4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3531 1.26367V8.72061H35.5054L26.3531 1.26367Z",
    fill: "#FFF2E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5054 9.4841H26.3532C25.9332 9.4841 25.5895 9.14046 25.5895 8.72046V1.26353C25.5895 0.969526 25.7575 0.698434 26.0248 0.572434C26.2921 0.446433 26.6052 0.484615 26.8343 0.671707L35.9865 8.12864C36.2385 8.33482 36.3301 8.67083 36.2232 8.97628C36.1163 9.28174 35.8261 9.4841 35.5054 9.4841V9.4841ZM27.1168 7.95682H33.3596L27.1168 2.87099V7.95682V7.95682Z",
    fill: "#FF8C4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09045 27.6051H8.34664M18.3923 16.3032V17.5594M28.438 27.6051H29.6942M10.355 19.5678L11.2332 20.446M26.4258 19.5678L25.5476 20.446",
    stroke: "#FFF2E6",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57495 27.1051H7.83114ZM17.8768 15.8032V17.0594ZM27.9225 27.1051H29.1787ZM9.83951 19.0716L10.7177 19.9498ZM25.9103 19.0716L25.0321 19.9498Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57495 27.1051H7.83114M17.8768 15.8032V17.0594M27.9225 27.1051H29.1787M9.83951 19.0716L10.7177 19.9498M25.9103 19.0716L25.0321 19.9498",
    stroke: "#FF8C4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 33.3286C12.6383 31.2477 12.077 27.3112 14.1579 24.5392C16.2388 21.7633 20.1754 21.2021 22.9474 23.283C25.7232 25.3639 26.2845 29.3004 24.2036 32.0725C23.8485 32.5497 23.4247 32.9697 22.9474 33.3286C21.9547 34.3137 21.485 35.7112 21.6912 37.0972C21.6912 38.4832 20.5687 39.6096 19.1788 39.6096C17.789 39.6096 16.6665 38.487 16.6665 37.0972C16.8726 35.715 16.4068 34.3137 15.4103 33.3286",
    fill: "#FFF2E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1082 32.1299C11.3324 30.049 10.7711 26.1124 12.8521 23.3404C14.933 20.5646 18.8695 20.0033 21.6415 22.0842C24.4174 24.1652 24.9786 28.1017 22.8977 30.8737C22.5426 31.351 22.1188 31.771 21.6415 32.1299C20.6488 33.115 20.1792 34.5125 20.3854 35.8985C20.3854 37.2845 19.2628 38.4108 17.873 38.4108C16.4832 38.4108 15.3606 37.2883 15.3606 35.8985C15.5668 34.5163 15.101 33.115 14.1044 32.1299",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1082 32.1299C11.3324 30.049 10.7711 26.1124 12.8521 23.3404C14.933 20.5646 18.8695 20.0033 21.6415 22.0842C24.4174 24.1652 24.9786 28.1017 22.8977 30.8737C22.5426 31.351 22.1188 31.771 21.6415 32.1299C20.6488 33.115 20.1792 34.5125 20.3854 35.8985C20.3854 37.2845 19.2628 38.4108 17.873 38.4108C16.4832 38.4108 15.3606 37.2883 15.3606 35.8985C15.5668 34.5163 15.101 33.115 14.1044 32.1299",
    stroke: "#FF8C4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9902 33.3862H20.7633",
    stroke: "#FF8C4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/solution.6ded821c2fcdd68bbb716fba8eb344ee.svg";
export { ForwardRef as ReactComponent };